import React from 'react';
import {stopPropagation, moment, returnNull, useNamedSelector, Moment} from 'helpers';
import {DatePicker} from 'components';
import css from './calendar.module.scss';

interface Props {
  start: Moment;
  end: Moment;
  Day: React.ComponentType<{date: Moment, today: Moment}>
}

export const Calendar = ({start, end, Day, ...props}: Props) => {
  const {today} = useNamedSelector('calendar.days');
  const includes = (date: Date | Moment) => start.isSameOrBefore(date) && end.isSameOrAfter(date);
  return (
    <DatePicker
      className={css.calendar}
      dayClassName={(date) => includes(date) ? '' : 'invisible'}
      fixedHeight={false}
      maxDate={end}
      monthsShown={2}
      openToDate={start.toDate()}
      renderCustomHeader={returnNull}
      renderDayContents={(_, date) => includes(date) && (
        <div onClick={stopPropagation}>
          <Day date={moment(date)} today={today} {...props} />
        </div>
      )}
    />
  );
};
